'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _FollowUserButton = require('../FollowUserButton');

var _FollowUserButton2 = _interopRequireDefault(_FollowUserButton);

var _propTypes = require('../../shared/prop-types');

var _FormattedTimeAgo = require('../shared/FormattedTimeAgo');

var _FormattedTimeAgo2 = _interopRequireDefault(_FormattedTimeAgo);

var _Pin = require('../shared/icons/Pin');

var _Pin2 = _interopRequireDefault(_Pin);

var _feedUserType = require('../../shared/feed-user-type');

var _feedUserType2 = _interopRequireDefault(_feedUserType);

var _feedUserUtil = require('../../utils/feed-user-util');

var _feedUserUtil2 = _interopRequireDefault(_feedUserUtil);

var _Uniform = require('../Uniform');

var _urls = require('../../utils/urls');

var _urls2 = _interopRequireDefault(_urls);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/no-multi-comp */


var defaultMarketingAccountId = '54ca65d70c794407b83085e9';

function showFollowButton(props) {
  if (props.hideFollowButton || !props.author) return false;
  return _feedUserUtil2.default.shouldShowFollowButton(props.currentUserId, props.author, props.content.targetCriteria);
}

var FeedItemContainer = function (_PureComponent) {
  _inherits(FeedItemContainer, _PureComponent);

  function FeedItemContainer() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, FeedItemContainer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FeedItemContainer.__proto__ || Object.getPrototypeOf(FeedItemContainer)).call.apply(_ref, [this].concat(args))), _this), _this.onProfileClick = function () {
      _this.props.onProfileClick({
        type: _this.props.author.feedUserId.type,
        relatedId: _this.props.author.feedUserId.relatedId
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(FeedItemContainer, [{
    key: 'render',
    value: function render() {
      var props = this.props;
      var author = props.author,
          isSponsored = props.isSponsored;

      var name = _feedUserUtil2.default.getFeedUserName(author);
      var initials = _feedUserUtil2.default.getFeedUserInitials(name);
      var profileImage = _feedUserUtil2.default.getFeedUserAvatar(author);
      var feedUserType = author && author.feedUserId ? author.feedUserId.type : _feedUserType2.default.Unknown;
      var profileUrl = author && author.feedUserId && _urls2.default.getFeedUserProfileUrl(feedUserType, author.feedUserId.relatedId);
      var isMarketingAccount = author && author.feedUserId && feedUserType === _feedUserType2.default.Hudl && author.feedUserId.relatedId === defaultMarketingAccountId;
      // Enable the profile link if not explicitly set to false and either the feed item
      // isn't in a timeline or the author isn't the timeline owner.
      var feedItemInTimeline = props.timelineUserId;
      var authorIsCurrentUser = !feedItemInTimeline || props.author && feedUserType === props.timelineUserId.type && author.feedUserId.relatedId === props.timelineUserId.relatedId;

      var profileLinkEnabled = !isMarketingAccount && !authorIsCurrentUser;
      var miniProfileEnabled = props.miniProfileEnabled && !isMarketingAccount;

      if (!author) {
        return null;
      }

      /* eslint-disable max-len */
      return _react2.default.createElement(
        'div',
        { className: 'feeditem ' + props.className, 'data-feed-content-id': props.feedContentId },
        _react2.default.createElement(
          _Uniform.Card,
          {
            header: _react2.default.createElement(
              'div',
              null,
              isSponsored && _react2.default.createElement(
                'div',
                { className: 'feeditem feeditem-sponsored' },
                _react2.default.createElement(
                  _Uniform.Subhead,
                  null,
                  _react2.default.createElement(
                    _Uniform.Text,
                    { level: 'small', color: 'subtle' },
                    'Sponsored'
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'feeditem-header feed-user-data' },
                miniProfileEnabled && (feedUserType === _feedUserType2.default.Hudl || feedUserType === _feedUserType2.default.Unknown) && _react2.default.createElement(_Uniform.AvatarOrg, { size: 'medium', imageUrl: profileImage, initials: initials, className: 'uni-margin--half--right', onClick: this.onProfileClick }),
                miniProfileEnabled && feedUserType === _feedUserType2.default.Team && _react2.default.createElement(_Uniform.AvatarTeam, { size: 'medium', imageUrl: profileImage, className: 'uni-margin--half--right', onClick: this.onProfileClick }),
                miniProfileEnabled && feedUserType === _feedUserType2.default.User && _react2.default.createElement(_Uniform.AvatarUser, { size: 'medium', imageUrl: profileImage, initials: initials, className: 'uni-margin--half--right', onClick: this.onProfileClick }),
                !miniProfileEnabled && profileLinkEnabled && (feedUserType === _feedUserType2.default.Hudl || feedUserType === _feedUserType2.default.Unknown) && _react2.default.createElement(
                  _Uniform.Link,
                  { type: 'wrapper', href: profileUrl },
                  _react2.default.createElement(_Uniform.AvatarOrg, { size: 'medium', imageUrl: profileImage, initials: initials, className: 'uni-margin--half--right', onClick: this.onProfileClick })
                ),
                !miniProfileEnabled && profileLinkEnabled && feedUserType === _feedUserType2.default.Team && _react2.default.createElement(
                  _Uniform.Link,
                  { type: 'wrapper', href: profileUrl },
                  _react2.default.createElement(_Uniform.AvatarTeam, { size: 'medium', imageUrl: profileImage, className: 'uni-margin--half--right', onClick: this.onProfileClick })
                ),
                !miniProfileEnabled && profileLinkEnabled && feedUserType === _feedUserType2.default.User && _react2.default.createElement(
                  _Uniform.Link,
                  { type: 'wrapper', href: profileUrl },
                  _react2.default.createElement(_Uniform.AvatarUser, { size: 'medium', imageUrl: profileImage, initials: initials, className: 'uni-margin--half--right', onClick: this.onProfileClick })
                ),
                !miniProfileEnabled && !profileLinkEnabled && (feedUserType === _feedUserType2.default.Hudl || feedUserType === _feedUserType2.default.Unknown) && _react2.default.createElement(_Uniform.AvatarOrg, { size: 'medium', imageUrl: profileImage, initials: initials, className: 'uni-margin--half--right' }),
                !miniProfileEnabled && !profileLinkEnabled && feedUserType === _feedUserType2.default.Team && _react2.default.createElement(_Uniform.AvatarTeam, { size: 'medium', imageUrl: profileImage, className: 'uni-margin--half--right' }),
                !miniProfileEnabled && !profileLinkEnabled && feedUserType === _feedUserType2.default.User && _react2.default.createElement(_Uniform.AvatarUser, { size: 'medium', imageUrl: profileImage, initials: initials, className: 'uni-margin--half--right' }),
                _react2.default.createElement(
                  'div',
                  { className: 'feedcontent' },
                  _react2.default.createElement(
                    _Uniform.Subhead,
                    { level: 'small', className: props.canDismiss || !props.isPinned ? 'feedmessage uni-pad--two--right' : 'feedmessage' },
                    miniProfileEnabled && _react2.default.createElement(
                      'span',
                      { className: 'name open-profile', onClick: this.onProfileClick },
                      name
                    ),
                    !miniProfileEnabled && profileLinkEnabled && _react2.default.createElement(
                      'a',
                      { className: 'name open-profile', href: profileUrl, onClick: this.onProfileClick },
                      name
                    ),
                    !miniProfileEnabled && !profileLinkEnabled && _react2.default.createElement(
                      'span',
                      { className: 'name' },
                      name
                    ),
                    _react2.default.createElement(
                      'span',
                      { className: 'action' },
                      ' ',
                      props.title
                    ),
                    _react2.default.createElement(
                      'span',
                      { className: 'feedmessage-tags' },
                      ' ',
                      props.tagsComponent || null
                    )
                  ),
                  _react2.default.createElement(
                    _Uniform.Text,
                    { level: 'micro', color: 'nonessential', className: 'uni-margin--eighth--top' },
                    _react2.default.createElement(_FormattedTimeAgo2.default, { time: props.date })
                  )
                ),
                props.isPinned && _react2.default.createElement(
                  'div',
                  { className: 'pinned-feed-item' },
                  _react2.default.createElement(_Pin2.default, null)
                ),
                showFollowButton(props) && _react2.default.createElement(_FollowUserButton2.default, { feedUserId: props.author.feedUserId, logData: props.logData }),
                props.canDismiss && !props.isPinned && _react2.default.createElement(
                  'div',
                  { className: 'dismiss-btn-container' },
                  _react2.default.createElement(
                    'button',
                    { className: 'uni-dismiss uni-notice__dismiss', onClick: props.onDismissFeedItem },
                    _react2.default.createElement(_Uniform.Icon, { size: 'medium', type: 'uidismiss' })
                  )
                )
              )
            )
          },
          props.isPinned && _react2.default.createElement(
            'div',
            { className: 'feeditem-controls' },
            _react2.default.createElement(
              'div',
              { className: 'pinned-feed-item' },
              _react2.default.createElement(_Pin2.default, null),
              'Pinned'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'feeditem-content' },
            props.children,
            props.content.showReactions && props.reactionComponent
          ),
          !props.hideCtaButtons && (props.shareButton || props.addReactionButton) && _react2.default.createElement(
            'div',
            { className: 'uni-card__footer', style: { marginBottom: '-0.5rem' } },
            props.addReactionButton,
            props.shareButton
          )
        )
      );
    }
  }]);

  return FeedItemContainer;
}(_react.PureComponent);

FeedItemContainer.propTypes = {
  author: _propTypes.FeedUser,
  canDismiss: _react.PropTypes.bool,
  children: _react.PropTypes.instanceOf(Object).isRequired,
  className: _react.PropTypes.string,
  content: _react.PropTypes.shape({
    showReactions: _react.PropTypes.boolean
  }).isRequired,
  currentUserId: _react.PropTypes.string,
  date: _react.PropTypes.string.isRequired,
  feedContentId: _react.PropTypes.string,
  hasTargetCriteria: _react.PropTypes.bool,
  hideFollowButton: _react.PropTypes.bool,
  miniProfileEnabled: _react.PropTypes.bool,
  onDismissFeedItem: _react.PropTypes.func,
  onProfileClick: _react.PropTypes.func,
  origin: _react.PropTypes.string,
  profileLinkEnabled: _react.PropTypes.bool,
  reactionComponent: _react.PropTypes.instanceOf(Object),
  addReactionButton: _react.PropTypes.instanceOf(Object),
  shareButton: _react.PropTypes.instanceOf(Object),
  tagsComponent: _react.PropTypes.instanceOf(Object),
  timelineUserId: _propTypes.FeedUserId,
  title: _react.PropTypes.string,
  isPinned: _react.PropTypes.bool,
  hideCtaButtons: _react.PropTypes.bool,
  logData: _react.PropTypes.object,
  isSponsored: _react.PropTypes.bool
};
exports.default = FeedItemContainer;